import { Controller } from "@hotwired/stimulus"

// Click a column header to sort the rows of a results table. Cells may carry
// data-value (ISO date, raw number) so "25.07.1990." and "1.405" sort right.
export default class extends Controller {
  sort(event) {
    const th = event.currentTarget
    const index = Array.from(th.parentNode.children).indexOf(th)
    const kind = th.dataset.sort || "text"
    const asc = th.dataset.dir !== "asc"
    th.parentNode.querySelectorAll("th").forEach((h) => { delete h.dataset.dir })
    th.dataset.dir = asc ? "asc" : "desc"

    const tbody = this.element.tBodies[0]
    const rows = Array.from(tbody.rows)
    const key = (row) => {
      const cell = row.cells[index]
      const raw = cell.dataset.value ?? cell.textContent.trim()
      if (kind === "number") return parseFloat(raw.replace(/\./g, "").replace(",", ".")) || 0
      return raw.toLocaleLowerCase("hr")
    }
    rows.sort((a, b) => {
      const x = key(a), y = key(b)
      const r = typeof x === "number" ? x - y : x.localeCompare(y, "hr")
      return asc ? r : -r
    })
    rows.forEach((r) => tbody.appendChild(r))
  }
}
